import { noop, uniqBy } from 'lodash';
import { injectIntl, FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { breakpoint } from '@zocdoc/components/src/grid';
import { Badges } from '@zocdoc/components/src/icons';
import { FontFamily } from '@zocdoc/components/src/typography';
import { BadgeMap, LOCALIZED_NAMES, LOCALIZED_TOOLTIPS } from './constants';
import { Tooltip, TOOLTIP } from '@zocdoc/components/src/Tooltip';
import { debounceTooltipTracking } from '../../utils/debounceTooltipTracking';

class BaseBadgeList extends React.PureComponent {
    static propTypes = {
        badges: PropTypes.arrayOf(PropTypes.string),
        trackClickRapidRegistration: PropTypes.func.isRequired,
        trackClickSeeYouAgain: PropTypes.func.isRequired,
        trackClickSpeedyResponse: PropTypes.func.isRequired,
        trackClickSchedulingHero: PropTypes.func.isRequired,
    }

    render() {
        const badges = uniqBy(this.props.badges, it => BadgeMap[it]);
        return (
            <div>
                {badges.map(this.renderBadge)}
            </div>
        );
    }

    renderBadge = badge => {
        const id = BadgeMap[badge];
        let trackingFn;
        if (this.props[`trackClick${id}`]) {
            trackingFn = debounceTooltipTracking(this.props[`trackClick${id}`]);
        } else {
            trackingFn = noop;
        }
        if (id) {
            const Badge = Badges[id];
            const anchor = (
                <Anchor>
                    <Badge alt={this.props.intl.formatMessage(LOCALIZED_TOOLTIPS[id])} />
                    <BadgeText><FormattedMessage {...LOCALIZED_NAMES[id]} /></BadgeText>
                </Anchor>
            );
            return (
                <BadgeHolder key={id}>
                    <StyledTooltip
                        anchor={anchor}
                        onDisplayTooltip={trackingFn}
                        showTooltipOnFocus
                        showTooltipOnHover
                        tooltipPosition={TOOLTIP.BOTTOM}
                    >
                        <FormattedMessage {...LOCALIZED_TOOLTIPS[id]} />
                    </StyledTooltip>
                </BadgeHolder>
            );
        }
    }
}

const BadgeHolder = styled.div`
    display: inline-block;
    text-align: center;
    margin-top: 12px;
    margin-right: 28px;
    width: 128px;
    font: 13px/20px ${FontFamily.SharpSansSemibold};

    ${breakpoint.medium} {
        font: 15px/24px ${FontFamily.SharpSansSemibold};
    }

    &:last {
        margin-right: 0;
    }
`;

const Anchor = styled.div`
    svg {
        font-size: 59.5938px;
    }
`;

const StyledTooltip = styled(Tooltip)`
    font: 16px/24px ${FontFamily.KievitSlabBook};
    text-align: left;

    ${breakpoint.small} {
        left: -50px;
        top: 100px;
        width: 250px;
        font: 12px/20px ${FontFamily.KievitSlabBook};
    }

    ${breakpoint.medium} {
        font-size: 14px;
    }
`;

const BadgeText = styled.div`
    line-height: 1.3;
    margin-top: 10px;
`;

export default injectIntl(BaseBadgeList);
